export const SPONSOR_ERROR_MESSAGE = 'Select a sponsor'

export function isValidSponsorAccountId(value) {
  const s = String(value ?? '').trim()
  return /^\d+$/.test(s)
}
